import type { SourceFile } from './engine-detection';

const MAX_TEXT_BYTES = 2 * 1024 * 1024;
const TEXT_EXTENSIONS = new Set([
  'cfg', 'conf', 'cs', 'env', 'gd', 'ini', 'java', 'js', 'json', 'md', 'py', 'sh',
  'toml', 'ts', 'txt', 'xml', 'yaml', 'yml',
]);
const BLOCKED_NAMES = [
  /^\.env/i,
  /^id_(?:rsa|dsa|ecdsa|ed25519)(?:\.pub)?$/i,
  /^credentials.*\.json$/i,
  /^service-account.*\.json$/i,
  /\.(?:key|p12|pfx|pem|keystore|jks)$/i,
];
const SECRET_PATTERNS = [
  /-----BEGIN (?:RSA |EC |OPENSSH )?PRIVATE KEY-----/,
  /\b(?:AKIA|ASIA)[A-Z0-9]{16}\b/,
  /\bgh[pousr]_[A-Za-z0-9]{30,255}\b/,
  /\bAIza[0-9A-Za-z_-]{35}\b/,
  /\bxox[baprs]-[0-9A-Za-z-]{20,}\b/,
];

export async function findCredentialFiles(files: SourceFile[]): Promise<string[]> {
  const matches = new Set<string>();
  for (const source of files) {
    const base = source.path.split('/').at(-1) ?? source.path;
    if (BLOCKED_NAMES.some((pattern) => pattern.test(base))) {
      matches.add(source.path);
      continue;
    }
    const extension = base.includes('.') ? base.split('.').at(-1)!.toLowerCase() : '';
    const textFile = base.startsWith('.') || TEXT_EXTENSIONS.has(extension);
    if (!textFile || source.file.size > MAX_TEXT_BYTES) continue;
    const text = await source.file.text();
    if (SECRET_PATTERNS.some((pattern) => pattern.test(text))) matches.add(source.path);
  }
  return [...matches];
}
